import { changeTimeZone } from "../utils";

const useRescheduleAllow = (startAtTime: any, TimeZone: any) => {
  const startDateTime = new Date(startAtTime * 1000);

  const appointmentStartTime = changeTimeZone(startDateTime, TimeZone);

  const dt = new Date();

  const currentSysTime = changeTimeZone(dt, TimeZone);

  function canReschedule(currentTime: any, startAtTime: any) {
    const timeDifference = startAtTime.getTime() - currentTime.getTime();
    const hoursDifference = timeDifference / (1000 * 60 * 60); // difference in hours

    if (hoursDifference > 24) {
      return true; // User can reschedule
    } else {
      return false; // User cannot reschedule
    }
  }

  const rescheduleAllowed = canReschedule(currentSysTime, appointmentStartTime);

  return { rescheduleAllowed };
};

export default useRescheduleAllow;
